function initializeHomeReconstructiveCarousel() {
  const mobileQuery = window.matchMedia('(max-width: 960px)');
  const blocks = document.querySelectorAll('.home-reconstructive .procedures-carousel');

  blocks.forEach((block) => {
    const track = block.querySelector('.procedures');
    const list = track ? track.querySelector('.procedures-list, ul') : null;
    const previousButton = block.querySelector('.procedures-arrow--prev');
    const nextButton = block.querySelector('.procedures-arrow--next');

    if (!track || !list || !previousButton || !nextButton) return;

    const cleanupDesktop = () => {
      list.querySelectorAll('[data-carousel-clone="true"]').forEach((item) => item.remove());
      delete list.dataset.carouselReady;
      track.scrollLeft = 0;
    };

    if (!mobileQuery.matches) {
      cleanupDesktop();
      return;
    }

    if (list.dataset.carouselReady === 'true') return;

    const originalItems = Array.from(list.children);

    if (originalItems.length < 2) {
      previousButton.hidden = true;
      nextButton.hidden = true;
      return;
    }

    const beforeFragment = document.createDocumentFragment();
    const afterFragment = document.createDocumentFragment();

    originalItems.forEach((item) => {
      const beforeClone = item.cloneNode(true);
      const afterClone = item.cloneNode(true);

      beforeClone.setAttribute('aria-hidden', 'true');
      afterClone.setAttribute('aria-hidden', 'true');
      beforeClone.dataset.carouselClone = 'true';
      afterClone.dataset.carouselClone = 'true';
      beforeClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
      afterClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
      beforeFragment.appendChild(beforeClone);
      afterFragment.appendChild(afterClone);
    });

    list.insertBefore(beforeFragment, list.firstChild);
    list.appendChild(afterFragment);
    list.dataset.carouselReady = 'true';

    const getItems = () => Array.from(list.children);
    const getTrackCenter = () => track.scrollLeft + track.clientWidth / 2;
    const getItemCenter = (item) => item.offsetLeft + item.offsetWidth / 2;
    const getOriginalWidth = () => list.children[originalItems.length * 2].offsetLeft - list.children[originalItems.length].offsetLeft;
    const scrollItemToCenter = (item, behavior = 'smooth') => track.scrollTo({ left: getItemCenter(item) - track.clientWidth / 2, behavior });
    const resetToOriginalSet = (behavior = 'auto') => scrollItemToCenter(list.children[originalItems.length], behavior);

    const normalizeLoop = () => {
      const firstOriginalCenter = getItemCenter(list.children[originalItems.length]);
      const firstAfterCenter = getItemCenter(list.children[originalItems.length * 2]);
      const originalWidth = getOriginalWidth();
      const trackCenter = getTrackCenter();

      if (trackCenter < firstOriginalCenter - 8) track.scrollLeft += originalWidth;
      if (trackCenter >= firstAfterCenter - 8) track.scrollLeft -= originalWidth;
    };

    const getCenteredItemIndex = () => {
      const trackCenter = getTrackCenter();

      return getItems().reduce((closestIndex, item, index) => {
        const closestDistance = Math.abs(getItemCenter(list.children[closestIndex]) - trackCenter);
        const itemDistance = Math.abs(getItemCenter(item) - trackCenter);

        return itemDistance < closestDistance ? index : closestIndex;
      }, 0);
    };

    const moveBy = (direction) => {
      normalizeLoop();
      const targetItem = getItems()[getCenteredItemIndex() + direction];
      if (targetItem) scrollItemToCenter(targetItem);
    };

    let snapTimeout;
    const snapToCenteredItem = () => {
      normalizeLoop();
      scrollItemToCenter(list.children[getCenteredItemIndex()]);
    };

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      moveBy(-1);
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      moveBy(1);
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(normalizeLoop);
      window.clearTimeout(snapTimeout);
      snapTimeout = window.setTimeout(snapToCenteredItem, 140);
    });

    window.addEventListener('resize', () => resetToOriginalSet());
    resetToOriginalSet();
  });
}

function readyHomeReconstructiveCarousel() {
  initializeHomeReconstructiveCarousel();
  window.matchMedia('(max-width: 960px)').addEventListener('change', initializeHomeReconstructiveCarousel);

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=home-reconstructive', initializeHomeReconstructiveCarousel);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', readyHomeReconstructiveCarousel);
} else {
  readyHomeReconstructiveCarousel();
}
